module.exports = __webpack_public_path__ + "img/waterproof-panel-logo.2338641c.png";